export function logger(namespace: String) {
  const loggerCreater = require("@hz/logger")
  return loggerCreater.createLogger(namespace, "trace")
}
